var exports = {
  "button": "MediaPlaybackRate.module__button___aXliRS",
  "small": "MediaPlaybackRate.module__small___aXliRS",
  "medium": "MediaPlaybackRate.module__medium___aXliRS",
  "large": "MediaPlaybackRate.module__large___aXliRS",
  "active": "MediaPlaybackRate.module__active___aXliRS",
  "label": "MediaPlaybackRate.module__label___aXliRS",
};

__webpack_require__.r(module.exports = exports);
